import {
  MontserratBold,
  MontserratBoldItalic,
  MontserratExtraBold,
  MontserratExtraBoldItalic,
  MontserratExtraLight,
  MontserratExtraLightItalic,
  MontserratItalic,
  MontserratLight,
  MontserratLightItalic,
  MontserratMedium,
  MontserratMediumItalic,
  MontserratRegular,
  MontserratSemiBold,
  MontserratSemiBoldItalic,
  MontserratThin,
  MontserratThinItalic,
} from '../../assets/fonts/Montserrat';
import {
  RobotoBlack,
  RobotoBlackItalic,
  RobotoBold,
  RobotoBoldItalic,
  RobotoLight,
  RobotoLightItalic,
  RobotoMedium,
  RobotoMediumItalic,
  RobotoRegular,
  RobotoRegularItalic,
  RobotoThin,
  RobotoThinItalic,
} from '../../assets/fonts/Roboto';
import { background, boxShadows } from './linkpick';

export const defaultColors = {
  white: '#fff',
  black: '#000',
};

export const defaultTheme = {
  props: {
    MuiUseMediaQuery: {
      noSsr: true,
    },
  },
  overrides: {
    MuiButton: {
      outlinedPrimary: {
        border: '1px solid #0060F9',
        fontWeight: 600,
        height: 40,
        fontSize: '13.5px!important',
        borderRadius: 400,
        '&:hover': { border: '1px solid #0060F9' },
      },
      outlinedSecondary: {
        border: '1px solid #F50057',
        color: '#F50057',
      },
      outlined: {
        border: '1px solid #C0D9FF',
        backgroundColor: '#F3F7FF',
        fontWeight: 600,
        fontSize: '13.5px!important',
        height: 40,
        color: '#5A6DA1',
        borderRadius: 400,
        '&:hover': { border: '1px solid #C0D9FF' },
      },
      text: {
        // border: '1px solid #C0D9FF',
        fontWeight: 600,
        fontSize: '13.5px!important',
        height: 40,
        color: '#5A6DA1',
        borderRadius: 400,
        // '&:hover': { border: '1px solid #C0D9FF' },
      },
      containedPrimary: {
        height: 40,
        fontSize: '13.5px!important',
        fontWeight: 600,
        borderRadius: 400,
        boxShadow: 'none',
        '&:hover': { boxShadow: 'none', },
      },
      containedSecondary: {
        height: 40,
        fontSize: '13.5px!important',
        fontWeight: 600,
        borderRadius: 5,
        boxShadow: 'none',
        '&:hover': { boxShadow: 'none', },
      },
      root: {
        borderRadius: 400,
      },
    },
    MuiTableRow: {
      root: {
        '&:last-child td': {
          borderBottom: 0,
        },
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid #C0D9FF',
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#C0D9FF',
      }
    },
    MuiTabs: {
      root: {
        minHeight: 40,
      }
    },
    MuiTab: {
      root: {
        minHeight: 40,
      }
    },
    MuiChip: {
      root: {
        borderRadius: '10.0px',
        padding: '15px!important'
      },
      label: {
        whiteSpace: "normal",
        textOverflow: "unset",
        paddingRight: 0,
        paddingLeft: 0,
      }
    },
    MuiAutocomplete: {
      tag: {
        padding: '0px!important',
        minHeight: '24px',
        height: 'auto'
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '13.5px!important',
        color: '#152652',
      }
    },
    MuiCollapse: {
      wrapper: {
        overflow: 'hidden',
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: '#F3F7FF',
      },
    },
    MuiAccordion: {
      root: {
        padding: 0,
        boxShadow: 'unset',
        border: '1px solid #C0D9FF',
        backgroundColor: '#F3F7FF',
        borderRadius: "10px!important",
        '&.Mui-expanded': {
          margin: 0,
        },
        '&:before': {
          content: 'unset',
        }
      }
    },
    MuiAccordionSummary: {
      root: {
        padding: 24,
      },
      content: {
        margin: 0,
        '&.Mui-expanded': {
          margin: 0,
        }
      },
      expandIcon: {
        padding: "0px 10px"
      }, 
    },
    MuiPaginationItem: {
      root: {
        fontSize: 12,
        color: '#5D75A8',
        fontFamily: 'Montserrat',
        minWidth: 24,
        minHeight: 24,
        height: 24,
        fontWeight: 500,
      '&:has(.MuiPaginationItem-icon)': {
        border: 'none',
        '&:hover': {
          border: 'none',
        },
      },
      },
      page: {
        border: '1px solid #c0d9ff',
        borderRadius: 400,
        '&.Mui-selected': {
          color: "#152652",
          backgroundColor: "white",
          border: 'unset',
          cursor: 'default',
        },
        "&.Mui-selected:hover ": {
          backgroundColor: "white!important",
        },
        '&:hover': {
          backgroundColor: 'white',
          border: '1px solid #0060F9',
          color: "#152652",
        },
        '&.Mui-disabled': {
          display: 'none',
        },
      }
    },
    MuiCssBaseline: {
      '@global': {
        'html, body, #root': {
          height: '100%',
        },
        button: {
          fontFamily: 'Montserrat',
        },
        '@font-face': [
          RobotoThin,
          RobotoThinItalic,
          RobotoLight,
          RobotoLightItalic,
          RobotoRegular,
          RobotoRegularItalic,
          RobotoMedium,
          RobotoMediumItalic,
          RobotoBold,
          RobotoBoldItalic,
          RobotoBlack,
          RobotoBlackItalic,
          MontserratBold,
          MontserratBoldItalic,
          MontserratExtraBold,
          MontserratExtraBoldItalic,
          MontserratExtraLight,
          MontserratExtraLightItalic,
          MontserratItalic,
          MontserratLight,
          MontserratLightItalic,
          MontserratMedium,
          MontserratMediumItalic,
          MontserratRegular,
          MontserratSemiBold,
          MontserratSemiBoldItalic,
          MontserratThin,
          MontserratThinItalic,
        ],
        '*::-webkit-scrollbar': {
          width: '0.3em',
          height: '0.3em',
          backgroundColor: '#F3F7FF',
        },
        '*::-webkit-scrollbar-track': {
          '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
          backgroundColor: '#C0D9FF',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#0060F9',
          outline: '1px solid white',
          borderRadius: 5,
        },
      },
    },
    MuiPaper: {
      elevation8: {
        "box-shadow": "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 400,

      },
    },
    MuiFilledInput: {
      root: {
        borderRadius: '400px',
        overflow: 'hidden',
      },
    },
  },
};